import { usePutEnvironment } from 'api/hooks'
import { useNavigate, useParams } from 'react-router-dom'
import { PUTEnvironmentRequestBody } from 'api/types'
import { Toaster } from '@matillion/component-library'
import { useTranslation } from 'react-i18next'
import { AutoCompleteProps } from 'types/FormTypes'
import { QueryKey } from 'constants/endpoint'
import { useQueryClient } from 'react-query'
import { SecretReferenceTypes } from 'types'
import { AppRoutes, PROJECT_DETAILS_ENVIRONMENTS } from 'constants/route'

export const useSubmitAssociateCloudCredentials = () => {
  const { projectId } = useParams()
  const { makeToast } = Toaster.useToaster()
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { mutateAsync: updateEnvironment } = usePutEnvironment(projectId!)

  const navigateToEnvironmentList = () => {
    queryClient.invalidateQueries([
      QueryKey.SECRET_REFERENCES,
      projectId!,
      SecretReferenceTypes.CLOUD_PLATFORM_CREDENTIALS
    ])
    queryClient.invalidateQueries([QueryKey.ENVIRONMENTS_LIST, projectId!])

    navigate(
      AppRoutes.getProjectDetails(projectId!, PROJECT_DETAILS_ENVIRONMENTS)
    )
  }

  const handleSubmit = ({
    requestBody,
    environment,
    setSubmitting
  }: {
    requestBody: PUTEnvironmentRequestBody
    environment: AutoCompleteProps
    setSubmitting: (isSubmitting: boolean) => void
  }) => {
    setSubmitting(true)
    updateEnvironment({
      values: requestBody,
      environmentId: environment.id
    })
      .then((_res) => {
        makeToast({
          title: t('associateCredentials.responseMessage.success', {
            environmentName: environment.name
          }),
          message: '',
          type: 'success'
        })
        navigateToEnvironmentList()
      })
      .catch((_err) => {
        makeToast({
          title: t('associateCredentials.responseMessage.error', {
            environmentName: environment.name
          }),
          message: '',
          type: 'error'
        })
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return handleSubmit
}
